import { type FC } from "react";
import { SelectBox, type OptionProps } from "@root/shared/components/SelectBox";
import { Icon } from "@root/shared/components/Icon";
import { TextButton } from "@root/shared/components/TextButton";
import {
  type DisplayDisableReason,
  type DisableButtonText,
} from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/type";
import { DisableAiScoutMessageButton } from "./uiParts/DisabledAiScoutMessageButton";
import * as styles from "./styles.css";

type Props = {
  options: OptionProps[];
  selectedValue: string | number;
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleClickOpenModal: () => void;
  hasDisableAiScoutMessageReason: boolean;
  disableText: DisableButtonText;
  displayDisableReason: DisplayDisableReason;
};

export const PcTemplateSelectAndAiTrigger: FC<Props> = ({
  options,
  selectedValue,
  handleSelectChange,
  handleClickOpenModal,
  hasDisableAiScoutMessageReason,
  disableText,
  displayDisableReason,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.selectWrapper}>
        <p>テンプレートを活用して効率的に入力！</p>
        <div className={styles.select}>
          <SelectBox
            name="form_client_frontend_premium_scout[client_user_scout_message_template_value]"
            className="js-pulldown-with-placehold js-notice-point-select-box-pc" // React外のJS操作が残っているため
            value={selectedValue}
            onChange={handleSelectChange}
            selected={!!selectedValue}
            placeholder="テンプレートを選択する"
            options={options}
          />
        </div>
      </div>
      {disableText && (
        <DisableAiScoutMessageButton
          disableText={disableText}
          displayDisableReason={displayDisableReason}
        />
      )}
      {!hasDisableAiScoutMessageReason && !disableText && (
        <TextButton type="button" size="small" onClick={handleClickOpenModal}>
          <Icon name="sparkle" fontSize="16px" />
          <span className={styles.buttonText}>AIでメッセージを作成</span>
        </TextButton>
      )}
    </div>
  );
};
